function getDatePickerValue(start, end) {
    if (start instanceof Date) {
        return {
            start,
            end,
        };
    }
    return start;
}
export function isDateSame(date1, date2) {
    const { start, end } = getDatePickerValue(date1, date2) || {};
    if (start == null || end == null) {
        return false;
    }
    return (start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate());
}
//# sourceMappingURL=isDateSame.js.map